import { Alert, Table, TableColumnsType } from 'antd';

interface BalanceObject {
  id: number;
  optType: string;
  price: number;
  unit: string;
}

const dataSource: BalanceObject[] = [
  {
    id: 1,
    optType: '文件上传',
    price: 0.08,
    unit: '次',
  },
  {
    id: 2,
    optType: '视频编辑插件',
    price: 0.05,
    unit: '次',
  },
  {
    id: 3,
    optType: '邮件发送接口',
    price: 0.05,
    unit: '次',
  },
  {
    id: 4,
    optType: '剪映草稿云渲染',
    price: 0.01,
    unit: '秒',
  },
  {
    id: 5,
    optType: '视频智能分镜',
    price: 0.01,
    unit: '秒',
  },
];

const Pricing = () => {
  const columns: TableColumnsType<BalanceObject> = [
    { title: '插件', dataIndex: 'optType' },
    {
      title: '价格',
      dataIndex: 'price',
      render: (text: number, record: BalanceObject) => {
        return (
          <span>
            {text} 积分/{record.unit}
          </span>
        );
      },
    },
  ];
  return (
    <>
      <Alert
        message="仅当您使用需 API Key 的接口时会计费，其余所有接口均可免费无限次调用；计费规则可能随时调整，请以实际扣费为准。如有疑问，请联系客服。"
        type="info"
        showIcon
      />
      <Table<BalanceObject>
        size="small"
        className="mt-2"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </>
  );
};
export default Pricing;
